import React from "react";
import { AccountLink } from "../account/AccountLink.js";
import { EntryLink } from "../entry/EntryLink.js";
import { FormattedAmount } from "../FormattedAmount.js";
import { QueryItem } from "../../../model/accounting/query/QueryItem.js";
import { FormattedDate } from "../FormattedDate.js";

type Props = {
  queryItem: QueryItem;
};

/**
 * Renders one item under VAT report field.
 */
export const FieldItem = ({ queryItem }: Props) => {
  return (
    <tr>
      <td colSpan={1}></td>
      <td colSpan={1}>
        <FormattedDate date={queryItem.item.date} />
      </td>
      <td colSpan={2}>
        <AccountLink accountId={queryItem.item.debit} />
      </td>
      <td colSpan={2}>
        <AccountLink accountId={queryItem.item.credit} />
      </td>
      <td colSpan={4}>
        <EntryLink entryId={queryItem.entry.id}>
          {queryItem.entry.title} - {queryItem.item.title}
        </EntryLink>
      </td>
      <td colSpan={1} className="text-right">
        <FormattedAmount cents={queryItem.item.eurAmount} />
      </td>
    </tr>
  );
};
